/// <amd-module name="typeahead/features/SelectInputElement" />
/// <amd-dependency path="jquery" name="$"/>

import {IInputElementFocusHandler} from "typeahead/core/presentation/IInputElementFocusHandler";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration = <IStripingConfiguration> {};

// This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
// For details of that investigation, see:
// https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
//
// Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
// tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
const inapplicableClients: string[] = ["Flights.Search"];

export class SelectInputElementOnFocus implements IInputElementFocusHandler<void> {
    public handleInputElementFocus($inputElement: JQuery, context: IContext): JQueryPromise<void> {
        if (inapplicableClients.lastIndexOf(context.clientId) < 0 && $($inputElement).val()) {
            let selectAllText = () => {
                let htmlInputEl: HTMLInputElement = <HTMLInputElement> $($inputElement)[0];
                if (htmlInputEl) {
                    htmlInputEl.setSelectionRange(0, 9999);
                }
            };
            setTimeout(() => {
                $($inputElement).one("mouseup", () => {
                    selectAllText();
                });
                selectAllText();
            }, 0);
        }
        return ($.Deferred() as JQueryDeferred<undefined>).resolve().promise();
    }
}
